<template lang="pug">
  .austria
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/austria-min.png"
      )
      span {{ gettext('Австрия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Австрия весьма благополучная страна в сфере экономики, уровня жизни и социального обеспечения граждан. Она находится в центре Европы, чем обеспечивает себе выгодное экономическое положение. В Европе очень высоко ценится образование, полученное именно в Австрийских учебных учреждениях.') }}
        p {{ gettext('В плане экономики страна известна всему миру своим туристическим сектором, который включает горнолыжные курорты, гостиницы и оздоровительные комплексы, множество парков и национальных заповедников. Десятки тысяч людей каждый год приезжают в Австрию в поиске впечатлений.') }}
        p {{ gettext('Именно в этом секторе и связанных с ним, большинство иностранцев находят себе работу, в особенности популярной является сезонная занятость. Сфера туризма непрерывно развивается и в связи с этим страна нуждается в квалифицированных технических рабочих и строителях.') }}
        P {{ gettext('Австрия заботится в первую очередь о трудоустройстве своих граждан, поэтому количество рабочей силы в лице иностранных работников регламентируется ежегодной квотой. Количество иностранных гастарбайтеров из третьих стран мира не должно превышать 8% от общего количества работников на рынке труда. Таким образом для ведения трудовой деятельности в Австрии необходимо получить на это разрешение и визу/вид на жительство.') }}
        P {{ gettext('Состоянием на 2018 год в Австрии проживает всего 1,395,880 иностранцев, из них 64,5 % трудоустроены. Больше всего в Австрии проживает немцев, сербов, турков, румын, граждан Боснии и Герцеговины, Венгрии, Хорватии и Польши.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/austria-min.png'})
  },
  name: 'Austria',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Austria | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/austria/index.vue